import React, {Component} from 'react';
import './ItemList.css';

class TechList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  createItems() {
    return this.props.technologies.map((techs) => {
      const name = techs.title;
      const url = techs.url;
      return <li key={url}>
        <a href={url}>{name}</a>
      </li>;
    });
  }

  render() {
    if(!this.props.technologies || this.props.technologies.length === 0){
      return null;
    }
    else{
      return <div>
        <h2>Technologie</h2>
        <ul className="itemlist">{this.createItems()}</ul>
      </div>
    }

  }
}

export default TechList;




// WEBPACK FOOTER //
// ./src/components/TechList.js